import NeptuneElement from '../../NeptuneElement.js';

class Tag extends NeptuneElement {

    static TAG_TYPES = ['default', 'high', 'medium', 'low', 'special'];

    templateMarkup = `<span><i class="fa-solid" hidden></i><slot></slot></span>`;
    componentCssUrl = '/src/components/core/tag/tag.css';

    constructor() {
        super();
    }

    async connectedCallback() {
        await super.connectedCallback();
        this.validateRequiredProperties(['type']);
        await Promise.resolve(); 
        this.processInitialAttributesAfterRender(Tag.observedAttributes);
    }

    async disconnectedCallback() {
        await super.disconnectedCallback();
    }

    static get observedAttributes() {
        return ['icon', 'type'];
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (!this.isRendered) {
            return;
        }
        this.processAttribute(name, oldValue, newValue);
    }

    processAttribute(name, oldValue, newValue) {
        switch (name) {
            case 'type': {
                this.validatePropertyValue(name, newValue, Tag.TAG_TYPES);
                break;
            }
            case 'icon': {
                const leftIcon = this.shadowRoot?.querySelector('i');
                if (leftIcon) {
                    if (newValue) {
                        leftIcon.className = `fa-solid ${newValue}`;
                        leftIcon.removeAttribute('hidden');
                    } else {
                        leftIcon.className = 'fa-solid';
                        leftIcon.setAttribute('hidden', '');
                    }
                }
                break;
            }
            default: {
                break;
            }
        }
    }
}

customElements.define('neptune-tag', Tag);
export default Tag;